import React from 'react'

const About = () => {
    return (
        <div name='about' className=' w-full h-screen bg-[#0a192f] text-gray-300 px-4'>
            <div className='flex flex-col justify-center items-center w-full h-full'>

                <div className='max-w-[1000px] w-full  grid grid-cols-2	 gap-8'>
                    <div className='sm:text-right pb-8 pl-4'>
                        <p className='text-4xl   font-bold inline border-b-4 border-pink-600 '>About</p>
                    </div>

                    <div></div>
                </div>

                <div className='max-w-[1000px] w-full grid sm:grid-cols-2 gap-8 px-4'>
                    <div className='sm:text-right text-4xl font-bold'>
                        <p>Hi,I'm Shriram, Nice to meet you, Please take  a look around.</p>
                    </div>
                    <div className='text-2xl'>
                        <p>I am a Front developer based in Mumbai, India. I have completed a bachelor of engineering from MU. I'm passionate about creating beautiful, functional, and user-friendly websites and applications, and I'm constantly pushing myself to learn and grow as a developer.</p>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default About
